<template>
  <v-card>
    <v-toolbar :dense="true" >
      <v-toolbar-title> <v-icon>mdi-note-text</v-icon> Text </v-toolbar-title>
      <v-spacer />
      <span class="body-2">Claim No: {{ this.commonInfo.clmNo }}</span>
    </v-toolbar>
    <v-tabs v-model="tabNavigation">
      <v-tab :active-class="'primary darken-1 white--text'"
        ><v-icon>mdi-page-layout-header</v-icon><span style="margin-left: 10px">Header</span></v-tab
      >
      <template v-if="claimTextData.claimantTexts && claimTextData.claimantTexts.length > 0">
        <template v-for="claimant in claimTextData.claimantTexts">
          <v-tab :active-class="'primary darken-1 white--text'" :key="claimant.clmtNo"
            ><v-icon>mdi-account</v-icon><span style="margin-left: 10px">Claimant {{ claimant.clmtNo }}</span></v-tab
          >
        </template>
      </template>
      <v-tab-item :key="0">
        <v-card :flat="true" height="300px">
          <v-card-text>
            <v-layout justify-center>
              <v-textarea
                data-vv-scope="text"
                no-resize
                rows="10"
                :label="labels.masterText"
                v-model="claimTextData.text"
                v-validate="'entry'"
                :error-messages="errors.collect('text.masterText')"
                data-vv-name="masterText"
                :data-vv-as="labels.masterText"
              ></v-textarea>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <template v-if="claimTextData.claimantTexts && claimTextData.claimantTexts.length > 0">
        <template v-for="claimant of claimTextData.claimantTexts">
          <v-tab-item :key="claimant.clmtNo">
            <v-card :flat="true" height="300px">
              <v-card-text>
                <span class="body-2">Name: {{ claimant.clmtName }}</span>
                <v-layout justify-center>
                  <v-textarea
                    data-vv-scope="text"
                    no-resize
                    rows="3"
                    :label="labels.claimantText + ' ' + claimant.clmtNo"
                    v-model="claimant.text"
                    v-validate="'entry'"
                    :error-messages="errors.collect('text.' + labels.claimantText + ' ' + claimant.clmtNo)"
                    :data-vv-name="labels.claimantText + ' ' + claimant.clmtNo"
                    :data-vv-as="labels.claimantText + ' ' + claimant.clmtNo"
                  ></v-textarea>
                </v-layout>
                <template v-if="claimant.itemTexts && claimant.itemTexts.length > 0">
                  <template v-for="(itemText, index) of claimant.itemTexts">
                    <template v-if="itemText.value === claimant.value">
                      <v-layout justify-center :key="index">
                        <v-text-field
                          data-vv-scope="text"
                          :label="labels.itemText + ' ' + itemText.clmItem"
                          v-model="itemText.text"
                          v-validate="'entry'"
                          :error-messages="errors.collect('text.' + labels.itemText + itemText.clmItem)"
                          :data-vv-name="labels.itemText + itemText.clmItem"
                          :data-vv-as="labels.itemText + itemText.clmItem"
                        ></v-text-field>
                      </v-layout>
                    </template>
                  </template>
                </template>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </template>
      </template>
    </v-tabs>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click.native="doCancel" :loading="loading">Cancel</v-btn>
      <v-btn color="primary" text type="submit" @click.native="doSave" :loading="loading">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
export default {
  props: {
    load: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tabNavigation: 0,
      labels: {
        masterText: 'Header Text',
        claimantText: 'Claimant Text',
        itemText: 'Item Text'
      },
      claimTextData: {
        text: undefined,
        claimantTexts: []
      },
      loading: false
    }
  },
  watch: {
    load: function (value) {
      if (value) {
        this.fetchData()
      }
    }
  },
  computed: {
    claimDetail() {
      return this.$store.state.claims.claimDetail
    },
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    }
  },
  methods: {
    resetText() {
      this.resetValidator()
      this.resetMessages()
      this.claimTextData = {
        text: undefined,
        claimantTexts: []
      }
    },
    async fetchData() {
      const apiUrl = this.claimDetail.menu.claimText
      if (apiUrl) {
        this.loading = true
        try {
          const expand = {
            clmNo: this.commonInfo.clmNo
          }
          this.resetText()
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            this.claimTextData = result.data
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
      this.loading = false
    },
    async saveClaimText() {
      const apiUrl = this.claimDetail.menu.saveClaimText
      if (apiUrl) {
        this.loading = true
        try {
          const result = await this.$http.post(apiUrl, this.claimTextData)
          if (result.data) {
            this.claimTextData = result.data
            this.loading = false
            this.$toast.success('Claim texts have been saved successfully')
            this.$emit('close')
            return true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
      this.loading = false
      return false
    },
    doCancel() {
      this.$emit('close')
    },
    doSave() {
      this.resetValidator()
      this.resetMessages()
      this.$validator.validateAll('text').then((result) => {
        if (result) {
          this.saveClaimText()
        } else {
          this.promptFieldCheck()
        }
      })
    }
  },
  mounted() {
    this.fetchData()
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
